import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { FilterData, IndexType } from "components/Extra"
import classNames from "classnames"
import { Link } from "react-router-dom"
import DisputesTable from "pages/admin/Disputes/DisputesTable"
import { DisputesCards } from "pages/admin/Disputes/DisputesCards"
import { DisputesGrid } from "pages/admin/Disputes/DisputesGrid"
import { ChangeStatusDiputeModal } from "pages/admin/Disputes/Modals"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FilterByDateRangeModal } from "components/Extra/FilterByDateRangeModal"

export enum CurrentTapType {
  all = "disputes_all",
  pending = "disputes_pending",
  inProgress = "disputes_inProgress",
  solved = "disputes_solved",
  rejected = "disputes_rejected",
}

const tabs = [
  CurrentTapType.all,
  CurrentTapType.pending,
  CurrentTapType.inProgress,
  CurrentTapType.solved,
  CurrentTapType.rejected,
]

export interface Dispute {
  title: string
  id: string
  createdDate: string
  createdBy: string
  attachments: string[]
  status:
    | CurrentTapType.pending
    | CurrentTapType.solved
    | CurrentTapType.rejected
  description: string
}

interface DisputesProps {
  isDashboardPage?: boolean
}

export const disputesData: Dispute[] = [
  {
    title: "Complain Bottles Quality",
    id: "ID-145871",
    createdDate: "25 May, 2023",
    createdBy: "Amr Kamal",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.pending,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Delay Delivery",
    id: "ID-145872",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.solved,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Delay Delivery",
    id: "ID-145873",
    createdDate: "25 May, 2023",
    createdBy: "Amr Kamal",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.pending,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Complain Bottles Quality",
    id: "ID-145874",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.pending,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Delay Delivery",
    id: "ID-145875",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.solved,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Complain Bottles Quality",
    id: "ID-145876",
    createdDate: "25 May, 2023",
    createdBy: "Amr Kamal",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.pending,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
  {
    title: "Delay Delivery",
    id: "ID-145877",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    attachments: ["Image1.Png", "Document.Pdf"],
    status: CurrentTapType.rejected,
    description:
      "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  },
]

export const Disputes: React.FC<DisputesProps> = ({ isDashboardPage }) => {
  const { t } = useTranslation()

  const [currentTap, setCurrentTap] = useState(CurrentTapType.all)
  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedDisputes, setCheckedDisputes] = useState<Dispute[]>([])
  const [disputes, setDisputes] = useState<Dispute[]>([])
  const [filteredDisputes, setFilteredDisputes] = useState<Dispute[]>([])
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState<{
    open: boolean
    view: "respond" | "rejected"
    dispute: Dispute | null
  }>({
    open: false,
    view: "respond",
    dispute: null,
  })

  const navigate = useNavigate()

  useEffect(() => {
    setDisputes(disputesData)
    setFilteredDisputes(disputesData)
  }, [])

  const isAllChecked = useMemo(() => {
    return disputes.length > 0 && checkedDisputes.length === disputes.length
  }, [disputes, checkedDisputes])

  const checkedDisputeHandler = useCallback((dispute: Dispute) => {
    setCheckedDisputes(prev =>
      prev.includes(dispute)
        ? prev.filter(o => o !== dispute)
        : [...prev, dispute]
    )
  }, [])

  const toggleAllDisputes = useCallback(() => {
    setCheckedDisputes(isAllChecked ? [] : disputes)
  }, [isAllChecked, disputes])

  const changeTabHandler = useCallback(
    (tab: CurrentTapType) => {
      setCurrentTap(tab)
      if (tab === CurrentTapType.all) {
        setFilteredDisputes(disputes)
      } else {
        setFilteredDisputes(disputes.filter(o => o.status === tab))
      }
    },
    [disputes, setCurrentTap]
  )

  const resolveHandler = useCallback((dispute: Dispute) => {
    setOpenChangeStatusModal({
      open: true,
      view: "respond",
      dispute,
    })
  }, [])
  const rejectHandler = useCallback((dispute: Dispute) => {
    setOpenChangeStatusModal({
      open: true,
      view: "rejected",
      dispute,
    })
  }, [])
  const viewDetailsHandler = useCallback((dispute: Dispute) => {
    navigate(`/disputes/${dispute.id}`)
  }, [])
  const forwardToAdminHandler = useCallback((dispute: Dispute) => {}, [])
  const deleteProductHandler = useCallback((dispute: Dispute) => {}, [])

  const onDateRangeChange = (startDate: string, endDate: string) => {
    console.log("Selected date range:", startDate, "to", endDate)
  }


  if (isDashboardPage) {
    return (
      <>
        <FilterData
          data={disputes}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          bearerFilteredData={setFilteredDisputes}
          showFilterBtnInsteadOfToggle
        />

        {/* Modals */}
        <ChangeStatusDiputeModal
          currentView={openChangeStatusModal.view}
          isOpen={openChangeStatusModal.open}
          dispute={openChangeStatusModal.dispute}
          toggle={() =>
            setOpenChangeStatusModal({
              open: false,
              view: "respond",
              dispute: null,
            })
          }
        />

        <DisputesTable
          disputes={filteredDisputes}
          isAllChecked={isAllChecked}
          checkedDisputes={checkedDisputes}
          toggleAllDisputes={toggleAllDisputes}
          checkedDisputeHandler={checkedDisputeHandler}
          resolveHandler={resolveHandler}
          rejectHandler={rejectHandler}
          forwardToAdminHandler={forwardToAdminHandler}
          deleteProductHandler={deleteProductHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      </>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("disputes_disputes")}
        />
        <FilterByDateRangeModal
          onDateRangeChange={onDateRangeChange}
          className="mb-3"
        />
        <DisputesCards />
        <ul className="nav nav-pills mb-3 px-2">
          {tabs.map(tab => (
            <li
              className="nav-item"
              style={{ flex: 1, textAlign: "center" }}
              key={tab}
            >
              <Link
                to="#"
                className={classNames(
                  { active: currentTap === tab },
                  "nav-link"
                )}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => changeTabHandler(tab)}
              >
                {t(tab)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <FilterData
        data={disputes}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredDisputes}
      />

      {/* Modals */}
      <ChangeStatusDiputeModal
        currentView={openChangeStatusModal.view}
        isOpen={openChangeStatusModal.open}
        dispute={openChangeStatusModal.dispute}
        toggle={() =>
          setOpenChangeStatusModal({
            open: false,
            view: "respond",
            dispute: null,
          })
        }
      />

      {activeTab == "list-ul" ? (
        <DisputesTable
          disputes={filteredDisputes}
          isAllChecked={isAllChecked}
          checkedDisputes={checkedDisputes}
          toggleAllDisputes={toggleAllDisputes}
          checkedDisputeHandler={checkedDisputeHandler}
          resolveHandler={resolveHandler}
          rejectHandler={rejectHandler}
          forwardToAdminHandler={forwardToAdminHandler}
          deleteProductHandler={deleteProductHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      ) : (
        <DisputesGrid
          disputes={filteredDisputes}
          viewDetailsHandler={viewDetailsHandler}
          resolveHandler={resolveHandler}
          rejectHandler={rejectHandler}
          forwardToAdminHandler={forwardToAdminHandler}
        />
      )}
    </div>
  )
}
